import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { analytics } from 'Modules/Analytics'
import { PlatformPlan, FormationPlan } from 'TypeDefs/Checkout'
import { Platform } from 'Modules/Analytics/analytics'

type Location = ReturnType<typeof useLocation>

interface Option {
  firstName: string
  lastName: string
  phone: string
}

export const usePageView = (location: Location) => {
  const [referrer, setReferrer] = useState<string | null>(null)

  useEffect(() => {
    analytics.trackRouteChange(referrer)

    setReferrer(window.location.href)

    // Don’t need referrer in dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])
}

export interface UseIdentifyUserParams {
  userId?: string | number
  email?: string
  isAuthenticated: boolean
  option: Option
  nonprofitOrgId?: string | number | null
  funderOrgId?: number | null
}
//  TODO: add associate user call when we know how to associate user
export const useIdentifyUser = ({
  userId,
  email,
  isAuthenticated,
  option,
  nonprofitOrgId,
  funderOrgId,
}: UseIdentifyUserParams) => {
  const firstname = option?.firstName
  const lastname = option?.lastName
  const phone = option?.phone

  useEffect(() => {
    if (isAuthenticated && userId && email && (nonprofitOrgId || funderOrgId)) {
      const param = {
        email,
        userId,
        nonprofitOrgId,
        funderOrgId,
        ...(firstname && { firstname }),
        ...(lastname && { lastname }),
        ...(phone && { phone }),
        platform: analytics.getUserInfo().platform,
      }

      analytics.identifyUser(userId, param)
    }
  }, [
    isAuthenticated,
    userId,
    email,
    firstname,
    lastname,
    phone,
    nonprofitOrgId,
    funderOrgId,
  ])
}

export interface UseGroupParams {
  groupId: number
  formationPlan: FormationPlan | null
  platformPlan: PlatformPlan | null
  orgName: string | null
  platform: Platform
  platformPlanAddOns: string[]
}

export const useGroup = ({
  groupId /* This is funderOrg Id for funders and nonprofitOrg Id for nonprofits */,
  formationPlan,
  platformPlan,
  orgName,
  platform,
  platformPlanAddOns,
}: UseGroupParams) => {
  useEffect(() => {
    if (groupId) {
      analytics.associateUser(`${groupId}`, {
        formationPlan,
        platformPlan,
        name: orgName,
        platform,
        platformPlanAddOns,
      })
    }
  }, [
    groupId,
    formationPlan,
    platformPlan,
    orgName,
    platform,
    platformPlanAddOns,
  ])
}
